/**
 * Link to an order's page in superadmin v2, worked out from the API URL the
 * same way superadmin's startOrder.js finds this checkout:
 *   api.thefxry.com         -> superadmin-v2.thefxry.com
 *   staging-api.thefxry.com -> staging-superadmin-v2.thefxry.com
 * Anything else (localhost) gets null and the order number stays plain text.
 */
export const adminOrderUrl = (orderId, apiUrl = process.env.REACT_APP_API_URL) => {
  if (!orderId || !apiUrl) return null;
  try {
    const url = new URL(apiUrl);
    if (!/(^|-)api\.thefxry\.com$/.test(url.hostname)) return null;
    url.hostname = url.hostname.replace(
      /api\.thefxry\.com$/,
      "superadmin-v2.thefxry.com",
    );
    return `${url.origin}/order/?id=${encodeURIComponent(orderId)}`;
  } catch {
    return null;
  }
};
